import { Flex, Text } from '@radix-ui/themes';
import styles from './PageHeader.module.css';

type PageHeaderProps = {
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
  marginBottom?: React.ComponentProps<typeof Flex>['mb'];
};

function PageHeader({ title, subtitle, actions, marginBottom = '4' }: PageHeaderProps) {
  if (!actions) {
    return (
      <Flex direction="column" gap="1" mb={marginBottom}>
        <h1 className={styles.title}>{title}</h1>
        {subtitle && (
          <Text as="p" size="2" className={styles.subtitle}>
            {subtitle}
          </Text>
        )}
      </Flex>
    );
  }

  return (
    <Flex align="start" justify="between" mb={marginBottom}>
      <Flex direction="column" gap="1">
        <h1 className={styles.title}>{title}</h1>
        {subtitle && (
          <Text as="p" size="2" className={styles.subtitle}>
            {subtitle}
          </Text>
        )}
      </Flex>
      <Flex align="center" gap="2" flexShrink="0">
        {actions}
      </Flex>
    </Flex>
  );
}

export default PageHeader;
